import {Iterable} from 'immutable';
import createLogger from 'redux-logger';

export const loggerMiddleware = createLogger({
  stateTransformer: (state) => {
    return Object.keys(state).reduce((newState, stateKey) => {
      if (Iterable.isIterable(state[stateKey])) {
        newState[stateKey] = state[stateKey].toJS();
      } else {
        newState[stateKey] = state[stateKey];
      }
      return newState;
    }, {});
  },
  collapsed: true
});


// WEBPACK FOOTER //
// ./src/state/middleware/logger.js